/* eslint-disable no-console */
import { takeLatest, takeEvery, put } from 'redux-saga/effects';
import * as TypeActions from '../store/notificacao/actionsTypes';
import * as ToastTypeActions from '../store/toast/actionsTypes';
import { AUTH_LOGOUT } from '../store/auth/actionsTypes';
import BaseService from '../services/BaseService';
import {
  NOTIFICACAO_PREVIEW_SIZE,
  buildNotificacaoFilter,
  parseNotificacaoPage,
} from '../helpers/notificacao';

function* fetchUnreadCount() {
  try {
    const response = yield BaseService.get({ url: 'notificacoes/nao-lidas/count' });
    const count = response.data && response.data.count;
    yield put({
      type: TypeActions.NOTIFICACAO_FETCH_COUNT_SUCCESS,
      count: Number.isFinite(Number(count)) ? Number(count) : 0,
    });
  } catch (error) {
    console.log(error);
  }
}

function* fetchPreview() {
  try {
    const response = yield BaseService.post({
      url: `notificacoes/filter?p=0&s=${NOTIFICACAO_PREVIEW_SIZE}`,
      data: buildNotificacaoFilter({ arquivada: false }),
    });
    const page = parseNotificacaoPage(response.data);
    yield put({
      type: TypeActions.NOTIFICACAO_FETCH_PREVIEW_SUCCESS,
      items: page.rows,
    });
  } catch (error) {
    console.log(error);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao carregar notificações.',
    });
  }
}

function* markRead({ id, wasUnread }) {
  if (!id) return;
  try {
    const response = yield BaseService.patch({ url: `notificacoes/${id}/ler` });
    yield put({
      type: TypeActions.NOTIFICACAO_MARK_READ_SUCCESS,
      id,
      wasUnread,
      visualizadaEm: (response.data && (response.data.visualizadaEm || response.data.dataLeitura))
        || new Date().toISOString(),
    });
  } catch (error) {
    console.log(error);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Não foi possível marcar a notificação como lida.',
    });
  }
}

function* markAllRead({ tipo, modulo, arquivada }) {
  try {
    yield BaseService.patch({
      url: 'notificacoes/ler-todas',
      data: buildNotificacaoFilter({
        tipo,
        modulo,
        arquivada: arquivada === true || arquivada === false ? arquivada : false,
      }),
    });
    yield put({ type: TypeActions.NOTIFICACAO_MARK_ALL_READ_SUCCESS });
    yield put({ type: TypeActions.NOTIFICACAO_FETCH_COUNT });
    yield put({ type: TypeActions.NOTIFICACAO_FETCH_PREVIEW });
  } catch (error) {
    console.log(error);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Não foi possível marcar as notificações como lidas.',
    });
  }
}

function* markLote({ ids, lida, arquivada }) {
  const safeIds = (ids || []).filter((id) => id != null && id !== '');
  if (safeIds.length === 0) return;
  if (lida == null && arquivada == null) return;
  try {
    const data = { ids: safeIds };
    // Contrato atual: leitura = `visualizada` (UI ainda usa `lida` no action).
    if (lida === true || lida === false) data.visualizada = lida;
    if (arquivada === true || arquivada === false) data.arquivada = arquivada;
    yield BaseService.patch({
      url: 'notificacoes/lote',
      data,
    });
    yield put({ type: TypeActions.NOTIFICACAO_LOTE_SUCCESS });
    yield put({ type: TypeActions.NOTIFICACAO_FETCH_COUNT });
    yield put({ type: TypeActions.NOTIFICACAO_FETCH_PREVIEW });
  } catch (error) {
    console.log(error);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Não foi possível atualizar as notificações selecionadas.',
    });
  }
}

function* cleanNotificacoes() {
  yield put({ type: TypeActions.NOTIFICACAO_CLEAN });
}

function* watchNotificacao() {
  yield takeLatest(TypeActions.NOTIFICACAO_FETCH_COUNT, fetchUnreadCount);
  yield takeLatest(TypeActions.NOTIFICACAO_FETCH_PREVIEW, fetchPreview);
  yield takeEvery(TypeActions.NOTIFICACAO_MARK_READ, markRead);
  yield takeLatest(TypeActions.NOTIFICACAO_MARK_ALL_READ, markAllRead);
  yield takeLatest(TypeActions.NOTIFICACAO_LOTE, markLote);
  yield takeLatest(AUTH_LOGOUT, cleanNotificacoes);
}

export default watchNotificacao;
